import React from 'react';
import './index.css';
import BookingStats from '../../../components/dashboard/cards/bookings';
import PartiesStats from '../../../components/dashboard/cards/parties';
import PropertiesStats from '../../../components/dashboard/cards/properties';
import { useAuth } from '../../../context/AuthContext';
import BookingWidget from '../../../components/dashboard/data-tables/booking';
import PropertiesWidget from '../../../components/dashboard/data-tables/properties';

function Dashboard() {

  const { user } = useAuth();

  return (
    <section className='section dashboard-wrapper'>
      <div className='row p-3'>
        <div className='col-12'>
          <div className='dash-welcome rounded'>
            <h4 className='mb-0'>Welcome back</h4>
            <h4 className='mb-0 fw-bold'>{user.displayName}</h4>
          </div>
        </div>
        <div className='col-12'>
          <div className='row'>
            <div className='col-4'>
              <div className='card custom-shadow bg-white p-2 mt-3 border-0'>
                <BookingStats />
              </div>
            </div>
            <div className='col-4'>
              <div className='card custom-shadow bg-white p-2 mt-3 border-0'>
                <PartiesStats />
              </div>
            </div>
            <div className='col-4'>
              <div className='card custom-shadow bg-white p-2 mt-3 border-0'>
                <PropertiesStats />
              </div>
            </div>
          </div>
        </div>
        <div className='col-8'>
          <div className='card custom-shadow bg-white h-480 mt-3 border-0'>
            <div className='px-3 py-3'>
              <h5 className='mb-0'>New Bookings</h5>
            </div>
            <BookingWidget />
          </div>
        </div>
        <div className='col-4'>
          <div className='card custom-shadow bg-white h-480 mt-3 border-0'>
            <div className='px-3 py-3'>
              <h5 className='mb-0'>Properties</h5>
            </div>
            <PropertiesWidget />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
